// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

export default css`
  &.filter-pill {
    .pill-button {
      display: flex;
      min-width: 80px;
      height: 40px;
      background: #ffffff;
      border: 1px solid #9b9b9b;
      box-sizing: border-box;
      border-radius: 5px;
      justify-content: center;
      padding: 11px;
    }
    .pill-text {
      color: #1a1a1a;
      font-family: 'Nunito';
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 12px;
      margin-top: 2px;
      white-space: nowrap;
      text-transform: capitalize;
    }
    .pill-image {
      height: 18px;
      margin-left: 5px;
    }
  }
`;
